/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
import Vue from 'vue';

Vue.mixin({
  methods: {
    mathRoundOf(number) {
      return number ? (isNaN(number) ? '—' : Math.round(number)) : 0;
    },
    roundOf(number) {
      return typeof number !== 'undefined' ? (isNaN(number) ? '—' : parseFloat(number).toFixed(2)) : '—';
    },
    roundOfRainFall(value) {
      if (!value || isNaN(value)) {
        return '—';
      }
      return value > -1 ? parseFloat(value).toFixed(3) : '—';
    }
  }
});
